import React from "react";
import { useTranslation } from "react-i18next";
import { homeDeVuong } from "../assets/images";

const About = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="uppercase text-[18px] font-cormorant pt-[10px]">
        {t("about_us")}
      </p>
      <p className="bg-gray-200 border-[1px] mt-[10px] "></p>
      <section className="py-12 flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-6 ">
        <div className="md:w-1/2 flex justify-center">
          <img
            src={homeDeVuong}
            alt="Hotel Lobby"
            className="xl:w-[500px] xl:h-[600px] rounded shadow-lg object-cover"
          />
        </div>
        <div className="md:w-1/2">
          <h2 className="text-[38px] font-cormorant text-black">
            {t("WELCOME_TO_HOTEL")}
          </h2>
          <h3 className="text-[28px] font-cormorant uppercase text-[#D4AF37]  ">
            {t("HOTEL_NAME")}
          </h3>
          <h4 className="text-[24px] font-cormorant text-black italic">
            {t('HOTEL_NAME')} – {t("HOTEL_TAGLINE")}
          </h4>
          <p className="mt-4 text-gray-600 text-[18px] leading-relaxed">
            {t("HOTEL_DESCRIPTION")}
          </p>
          <p className="mt-4 text-gray-600 text-[18px] leading-relaxed">
            {t("HOTEL_DES2")}
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
